import { httpService } from "./httpService";

/**
 * Fetches tenant branding configuration (public endpoint, no auth required).
 * @returns {Promise<import("types/commonTypes").HttpResult<{companyName: string, primaryColor: string, secondaryColor: string, logoUrl: string}>>}
 */
export const getTenantBranding = async () =>
  httpService({
    url: "/tenant/branding",
    options: {
      method: "GET",
    },
  });
